export default __webpack_public_path__ + "static/media/search_empty.ee2ad6c8.png";